export default {"src":"/_next/static/media/Urinary Incontinence.a8bf9e94.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};